/* eslint-disable react/prop-types */
import { useEffect } from 'react'
import { Alert, Box, Collapse, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

export default function AlertSentEmail({ open, setOpen }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            setOpen(false)
        }, 3000);

        return () => clearTimeout(timer);
    }, [open]);
    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={open}>
                <Alert
                    sx={{ mb: 2 }}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    Your message has been sent !
                </Alert>
            </Collapse>
        </Box>
    )
}
